// extracted by mini-css-extract-plugin
module.exports = {"container":"TrustPilotReviews_container__4BLAP","row":"TrustPilotReviews_row__edXjQ"};